module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("86pTb"))).then(() => parcelRequire('haHsR'));